import { useState, useEffect } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function useImage(id) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function fetchImage() {
      setLoading(true);

      const { response, data } = await API.fetchImage(token, id);

      if (response.ok) {
        setResult(data);
        setLoading(false);
        setError(null);
      } else {
        setError(data);
        setLoading(false);
      }
    }

    fetchImage();
  }, [id, setResult, setLoading]);

  return {
    loading,
    error,
    image: result,
  };
}
